import React, {useCallback, useState} from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import HeaderSection from './HeaderSection';
import FooterSection from './FooterSection';
import MainArea from './MainArea';
import ActiveTile from './ActiveTile';
import InstallationsFilter from './InstallationsFilter';
import { InstallationsContext, GenericContext, MqttContext } from './App';
import { SITE_LINKS } from '../Contants';
import {timestampToDate} from '../utilities';
import {
  ALERT_TYPE_ALARM,
  // ALERT_TYPE_INSTALLATION,
  ALERT_TYPE_TECH_ALARM,
  ALERT_TYPE_TECH_WARNING,
  ALERT_TYPE_WARNING,
  FILTER_INST_BY_STATE_NO_DISABLED_FLAG,
  FILTER_INST_BY_STATE_NO_MAINTENANCE_FLAG,
  FILTER_INST_BY_STATE_NO_OK_FLAG,
  FILTER_INST_BY_STATE_NO_WARNING_FLAG,
  FILTER_INST_BY_STATE_NONE,
  INSTALLATION_ALERT_STATUS_ALARM,
  INSTALLATION_ALERT_STATUS_DISCONNECTED,
  INSTALLATION_ALERT_STATUS_NO_ALARM,
  INSTALLATION_ALERT_STATUS_WARNING,
  INSTALLATION_MODE_DISABLED,
  INSTALLATION_MODE_MAINTENANCE,
  INSTALLATION_MODE_MAINTENANCE_ALARM_TEST,
  INSTALLATION_MODE_NORMAL,
} from "../api/wimhome-api";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilter} from "@fortawesome/free-solid-svg-icons/faFilter";
import {useShortcut} from "../custom-hooks/use-shortcut";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import {faEye} from "@fortawesome/free-solid-svg-icons";
import PermanentAlertsBar from "./PermanentAlertsBar";

export default withRouter(function InstallationsPage(props) {
  const {
    currRoute,
    emptyInstallationFilter,
    history,
    installationsFilterInfo,
    setInstallationsFilterInfo
  } = props;
  const {t, i18n} = useTranslation();

  const {
    alerts,
    installations, 
    selectedInst, 
//    setSelectedInst,
    handleSelectInstallation,
    acknowledgeAlerts,
    alertCodes,
  } = React.useContext(InstallationsContext);
  const { errors, userOptions } = React.useContext(GenericContext);
  const { mqttStatus } = React.useContext(MqttContext);

  let mainContentRef = React.createRef();

  const [displayFilter, setDisplayFilter] = useState(installationsFilterInfo.title !== null || installationsFilterInfo.description !== null || installationsFilterInfo.id !== null);
  const [bypassUserOptionsFilter, setBypassUserOptionsFilter] = useState(false);

  useShortcut({ ctrl: true, key: "s" }, toggleDisplayFilter);
  useShortcut({ ctrl: true, key: "b" }, toggleDisplayBypassFilter);

  function toggleDisplayFilter() {
    if(displayFilter === true) {
      setInstallationsFilterInfo(emptyInstallationFilter)
    }
    setDisplayFilter(display => !display)
  }

  function toggleDisplayBypassFilter() {
    setBypassUserOptionsFilter(display => !display)
  }

  function installationOnClickHandler(e) {
//    setSelectedInst(e);
    if(alerts && alerts.get(e)) {
      acknowledgeAlerts(e, [...alerts.get(e).alerts]);
    }
    handleSelectInstallation(e);
    // console.log(e);
    history.push(SITE_LINKS.STATUS);
  }

  const decodeIconColor = useCallback((installation) => {
    if(installation.mode === INSTALLATION_MODE_NORMAL) {
      switch (installation.status) {
        case INSTALLATION_ALERT_STATUS_NO_ALARM:
          return "active-state";

        case INSTALLATION_ALERT_STATUS_WARNING:
          for (const alertsKey in installation.alerts) {
            const alert = installation.alerts[alertsKey];
            if (alertCodes != null && alertCodes?.has(alert.code)) {
              if (alertCodes.get(alert.code).type !== ALERT_TYPE_TECH_WARNING)
                return "warning-state";
            } else {
              return "warning-state";
            }
          }
          return "tech-warning-state";

        case INSTALLATION_ALERT_STATUS_DISCONNECTED:
          return "disconnected-state";

        case INSTALLATION_ALERT_STATUS_ALARM:
          for (const alertsKey in installation.alerts) {
            const alert = installation.alerts[alertsKey];
            if (alertCodes != null && alertCodes?.has(alert.code)) {
              if (alertCodes.get(alert.code).type !== ALERT_TYPE_TECH_WARNING && alertCodes.get(alert.code).type !== ALERT_TYPE_TECH_ALARM)
                return "alarm-state";
            } else {
              return "alarm-state";
            }
          }
          return "tech-alarm-state";

        default:
          return ""
      }
    }

    if(installation.mode === INSTALLATION_MODE_MAINTENANCE || installation.mode === INSTALLATION_MODE_MAINTENANCE_ALARM_TEST) {
      return "blue";
    }

    if(installation.mode === INSTALLATION_MODE_DISABLED) {
      return "gray";
    }

    return "";
  }, [alertCodes]);

  const compareAlert = useCallback((a, b) => {
    if(a === null && b === null)
      return 0;

    if(a === null)
      return 1;

    if(b === null)
      return -1;

    if(a.value > 0 && b.value < 0) {
      return -1;
    }

    if(a.value < 0 && b.value > 0) {
      return 1;
    }

    if(alertCodes != null && alertCodes?.has(a.code) && alertCodes?.has(b.code)) {
      if ((alertCodes.get(a.code).type === ALERT_TYPE_ALARM || alertCodes.get(a.code).type === ALERT_TYPE_WARNING) &&
          (alertCodes.get(b.code).type === ALERT_TYPE_TECH_ALARM || alertCodes.get(b.code).type === ALERT_TYPE_TECH_WARNING)) {
        return -1;
      }

      if ((alertCodes.get(a.code).type === ALERT_TYPE_TECH_ALARM || alertCodes.get(a.code).type === ALERT_TYPE_TECH_WARNING) &&
          (alertCodes.get(b.code).type === ALERT_TYPE_ALARM || alertCodes.get(b.code).type === ALERT_TYPE_WARNING)) {
        return 1;
      }
    }

    if(a.type > b.type) {
      return -1;
    }

    if(a.type < b.type) {
      return 1;
    }

    if(a.date > b.date) {
      return -1;
    }

    if(a.date < b.date) {
      return 1;
    }

    return 0;
  }, [alertCodes]);

  function calcHigherAlert(alertList) {
    if(alertList.length === 0) { return null }
    if(alertList.length === 1) { return alertList[0] }

    let higherAlertIdx = 0;
    for (let i = 1; i < alertList.length; i++) {
      if(compareAlert(alertList[higherAlertIdx], alertList[i]) < 0) {
        higherAlertIdx = i;
      }
    }
    return alertList[higherAlertIdx];
  }
  
  function filterInstallations(installationsObj, filterInstallations)
  {
    if(!installationsObj)
      return [];

    // if(filterInstallations.title == null && filterInstallations.description == null && filterInstallations.id == null)
    //   return installationsObj;

    return Object.values(installationsObj).filter((item) => {
      if(shouldHideInstallation(item)) {
        return false;
      }

      if(filterInstallations.filterAlarmed === false && item.status > 1 && item.mode === 0)
        return true;
      // Only match filter fields that are not null/empty strings
      for (const key of ["title", "description", "id"]) {
        if (filterInstallations[key] && filterInstallations[key].trim() !== "") {
          // Partial match, case-insensitive for usability
          if (
              !(
                  item[key] &&
                  item[key].toLowerCase().includes(filterInstallations[key].toLowerCase())
              )
          ) {
            return false;
          }
        }
      }
      return true;
    });
  }

  function shouldHideInstallation(installation)
  {
    if(bypassUserOptionsFilter)
      return false;

    let isHidden = false;
    if(userOptions?.filterInstByState !== null && userOptions?.filterInstByState !== FILTER_INST_BY_STATE_NONE) {
      if((userOptions.filterInstByState & FILTER_INST_BY_STATE_NO_DISABLED_FLAG) && (installation.mode === INSTALLATION_MODE_DISABLED))
        isHidden = true;
      if((userOptions?.filterInstByState & FILTER_INST_BY_STATE_NO_MAINTENANCE_FLAG) &&
          (installation.mode === INSTALLATION_MODE_MAINTENANCE || installation.mode === INSTALLATION_MODE_MAINTENANCE_ALARM_TEST))
        isHidden = true;
      if((userOptions?.filterInstByState & FILTER_INST_BY_STATE_NO_OK_FLAG) &&
          (installation.mode === INSTALLATION_MODE_NORMAL && installation.status === INSTALLATION_ALERT_STATUS_NO_ALARM))
        isHidden = true;
      if((userOptions?.filterInstByState & FILTER_INST_BY_STATE_NO_WARNING_FLAG) &&
          (installation.mode === INSTALLATION_MODE_NORMAL && installation.status === INSTALLATION_ALERT_STATUS_WARNING))
        isHidden = true;
    }
    return isHidden;
  }

  function reorderInstallations(installationsObj) {
    if(!installationsObj)
      return [];
      
    return Object.values(installationsObj).sort( (a, b) => {
      if(a.mode === b.mode) {
        if((a.status === INSTALLATION_ALERT_STATUS_ALARM || a.status === INSTALLATION_ALERT_STATUS_WARNING) &&
            (b.status === INSTALLATION_ALERT_STATUS_ALARM || b.status === INSTALLATION_ALERT_STATUS_WARNING)) {
          return compareAlert(calcHigherAlert(a.alerts), calcHigherAlert(b.alerts));
        }

        if (a.status === b.status) {
          if(a.status === INSTALLATION_ALERT_STATUS_DISCONNECTED) {
            // Order disconnected installation from newer to older disconnection timestamp
            return b.lastStatusUpdate - a.lastStatusUpdate;
          }

          // Installations without alerts are ordered by title
          if (a.title < b.title) {
            return -1;
          } else if (a.title > b.title) {
            return 1;
          }
          return 0;
        }
        return b.status - a.status;
      }
      const a_ord = a.mode === INSTALLATION_MODE_DISABLED ? 99 : a.mode
      const b_ord = b.mode === INSTALLATION_MODE_DISABLED ? 99 : b.mode
      return a_ord - b_ord;
    });
  }

  function reorderAlerts(alerts) {
    return alerts.sort( (a, b) => {
      if(a.type === b.type) {
        return a.date - b.date;
      }
      return b.type - a.type;
    });
  }

  function decodeIcon(installation) {
    if(installation.mode === INSTALLATION_MODE_NORMAL)
      return installation.status === INSTALLATION_ALERT_STATUS_DISCONNECTED ? "icon-pericolo" : "icon-casa"

    if(installation.mode === INSTALLATION_MODE_DISABLED)
      return "icon-casa"

    if(installation.mode === INSTALLATION_MODE_MAINTENANCE || installation.mode === INSTALLATION_MODE_MAINTENANCE_ALARM_TEST)
      return "icon-wrench"
  }

  const extractInstallationAlerts = useCallback((installation) => {
    if(typeof installation === 'undefined' || installation === null)
      return;

    if(installation.mode === INSTALLATION_MODE_DISABLED) {
      return (
        <div className="installation-alarm-summary">
          <span className="installation-inhibited-line">
            {`${t('installations.disabledSince')}`} {timestampToDate(installation.lastModeUpdate).toLocaleString(i18n.language)}
          </span>
          <br/>
        </div>
      )
    }

    if(installation.mode === INSTALLATION_MODE_MAINTENANCE) {
      return (
          <div className="installation-alarm-summary">
          <span className="installation-inhibited-line">
            {`${t('installations.inMaintenanceSince')}`} {timestampToDate(installation.lastModeUpdate).toLocaleString(i18n.language)}
          </span>
            <br/>
          </div>
      )
    }

    if(installation.mode === INSTALLATION_MODE_MAINTENANCE_ALARM_TEST) {
      return (
          <div className="installation-alarm-summary">
          <span className="installation-warning-line">
            {`${t('installations.inMaintenanceAlarmSince')}`} {timestampToDate(installation.lastModeUpdate).toLocaleString(i18n.language)}
          </span>
            <br/>
          </div>
      )
    }

    if(installation.status === INSTALLATION_ALERT_STATUS_NO_ALARM)
      return;

    return (
      <div className="installation-alarm-summary">
        {(installation.status === INSTALLATION_ALERT_STATUS_DISCONNECTED) && (
          <>
            <span className="installation-disconnected-line">
              {`${t('installations.disconnectedSince1')}`} {timestampToDate(installation.lastStatusUpdate).toLocaleString(i18n.language)}
            </span>
            <br/>
          </>
        )}
        {reorderAlerts(installation.alerts).map( (alert) => {
          let date = new Date();
          date.setTime(alert.date * 1000);
          let lineClassName = ""
          switch(alert.type) {
            case 0:
              lineClassName = "installation-inhibited-line";
            break;

            case 1:
              if (alertCodes != null && alertCodes?.has(alert.code) && alertCodes.get(alert.code).type === ALERT_TYPE_TECH_WARNING)
                lineClassName = "installation-tech-warning-line"
              else
                lineClassName = "installation-warning-line";
            break;

            default:
            case 2:
              if (alertCodes != null && alertCodes?.has(alert.code) && alertCodes.get(alert.code).type === ALERT_TYPE_TECH_ALARM)
                lineClassName = "installation-tech-alarm-line"
              else
                lineClassName = "installation-alarm-line";
            break;
          }
          return (
            <React.Fragment key={alert.deviceId}>
              <span className={lineClassName}>
                {date.toLocaleString(i18n.language)} {alert.title}
              </span>
              <br/>
            </React.Fragment>
          );
        })}
      </div>
    );
  }, [i18n, alertCodes]);
  
  const filteredInstallationsArray = filterInstallations(installations, installationsFilterInfo);
  const installationsArray = reorderInstallations(filteredInstallationsArray);
  const hiddenInstallationCount = (Object.values(installations ?? new Map())?.length ?? 0) - installationsArray?.length;

  let title = `${t('installations.title')}`;
  if(hiddenInstallationCount > 0) {
    title = <>
      {`${t('installations.title')} (${hiddenInstallationCount} ${t(hiddenInstallationCount === 1 ? 'installations.hidden1' : 'installations.hiddenN')}`}
      <FontAwesomeIcon icon={faInfoCircle} style={{marginLeft: "0.5em", fontSize: "1.5rem"}} title={`${t('installations.hiddenInstallationsTooltip')}`}/>
      )
    </>
  }

  return (
    <>
      <HeaderSection
          currRoute={currRoute}
          errors={errors}
          mainContentRef={mainContentRef}
          mqttStatus={mqttStatus}
          selectedInst={selectedInst}
      />
      <section className="main-content" ref={mainContentRef}>
        <PermanentAlertsBar />
        <MainArea
            headerAddOns={
              <span
                  className='options-menu-icon'
              >
                <FontAwesomeIcon
                    className={`options-menu-icon ${bypassUserOptionsFilter ? 'filter-bypass-active' : 'filter-inactive'}`}
                    icon={faEye}
                    onClick={toggleDisplayBypassFilter}
                    title={`${t('installations.bypassUserOptionsFilter')} (CTRL+B)`}
                />
                <FontAwesomeIcon
                    className={`options-menu-icon ${displayFilter ? 'filter-active' : 'filter-inactive'}`}
                    icon={faFilter}
                    onClick={toggleDisplayFilter}
                    title={`${t('installations.filter')} (CTRL+S)`}
                />
              </span>
            }
            title={title}
        >
          <InstallationsFilter displayFilter={displayFilter} filter={installationsFilterInfo} hideFilterAlarmed={false} setFilter={setInstallationsFilterInfo}/>
          {installationsArray.map( (installation) => {
            // console.log('installation: ', installation);
            return <ActiveTile
              key={installation.id}
              descType={""}
              details={installation.description}
//              hidden={shouldHideInstallation(installation)}
              iconName={ decodeIcon(installation) }
              moreDetails={extractInstallationAlerts(installation)}
              onClickHandler={ () => installationOnClickHandler(installation.id) }
              tileId={installation.id}
              tileState={decodeIconColor(installation)}
              title={installation.title}
            />
          })}
          {installationsArray.length === 0 && (
              <div>
                <p>{`${t('installations.noneToShow')}`}</p>
              </div>
          )}
        </MainArea>
      </section>
      <FooterSection/>
    </>
  )
});
